import { USDT, USDTAbi, oxyToken, oxyTokenAbi } from "../Contract";

/**
 * Every ERC20 the dApp can approve / read balances for.
 * Keyed by the short symbol used inside function definitions (`payment: [{ token: "USDT" }]`).
 */
export const TOKENS = {
  USDT: {
    key: "USDT",
    symbol: "USDT",
    label: "USDT",
    address: USDT,
    abi: USDTAbi,
    decimals: 18,
    icon: "💵",
    color: "#26a17b",
  },
  OXY: {
    key: "OXY",
    symbol: "OXY",
    label: "OXY Token",
    address: oxyToken,
    abi: oxyTokenAbi,
    decimals: 18,
    icon: "🪙",
    color: "#00ccff",
  },
};

export const MAX_UINT256 =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";

export default TOKENS;
